/**
 * dates.js — shared date formatting helpers.
 */

/** Returns "12 Jan" style short date for today */
export function todayShort() {
  return new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
}

/** Returns "12 Jan 2025" style full date */
export function formatDateFull(date) {
  return new Date(date).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric',
  })
}

/** Returns a YYYY-MM-DD string for today (useful for D1 / date inputs) */
export function todayISO() {
  return new Date().toISOString().slice(0, 10)
}

/** Days since epoch — used for daily rotation of quotes, missions, etc. */
export function dayIndex() {
  return Math.floor(Date.now() / 86400000)
}

/**
 * Calculates a consecutive-day streak from an array of entries
 * that each have a `ts` (timestamp in ms) field.
 */
export function calcStreak(entries) {
  if (!entries.length) return 0
  let streak = 1, max = 1
  for (let i = 1; i < entries.length; i++) {
    const diff = Math.round(
      (new Date(entries[i - 1].ts) - new Date(entries[i].ts)) / 86400000
    )
    if (diff === 1) { streak++; max = Math.max(max, streak) }
    else streak = 1
  }
  return max
}
